import React from 'react';
import { TextField, TextFieldProps, InputAdornment } from '@mui/material';

interface BWITextFieldProps extends Omit<TextFieldProps, 'variant'> {
  startIcon?: React.ReactNode;
}

const BWITextField: React.FC<BWITextFieldProps> = ({ startIcon, ...props }) => {
  return (
    <TextField
      {...props}
      variant="outlined"
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : undefined,
      }}
      fullWidth
    />
  );
};

export default BWITextField;
